import api from '../api';

export const inviteAdmin = (data) => api.post('/core/functions/inviteAdmin', data);

export const inviteTeacher = (data) => api.post('/core/functions/inviteTeacher', data);

export const inviteBusiness = (data) => api.post('/core/functions/inviteBusiness', data);
